import React, { lazy } from 'react';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';

const MobileAppRedirect = Loadable(
    lazy(() => import('pages/main-pages/MobileAppRedirect'))
);

// ==============================|| MISC ROUTING ||============================== //

const MiscRoutes = {
    path: '/',
    children: [
        {
            path: '/',
            element: <CommonLayout />,
            children: [
                {
                    path: 'app',
                    element: <MobileAppRedirect />
                }
            ]
        }
    ]
};

export default MiscRoutes;
